import { TariffUuid } from '@products/models/tariff.model';

export enum TicketSendingOption {
  AllToBuyer = 'allToBuyer',
  NormalPerOwner = 'normalPerOwner',
  MobilePerBuyer = 'mobilePerBuyer',
  MobilePerOwner = 'mobilePerOwner',
  TicketRetrievalLinkBuyer = 'ticketRetrivalLinkBuyer',
  TicketRetrievalLink = 'ticketRetrivalLink'
}

export type SelectedTicketSendingOptions = Record<TariffUuid, TicketSendingOption>;
